export default __webpack_public_path__ + "static/media/Factory.b1912cae.svg";